/**
 * Shown on every page when the server's answer about the signed in person failed. The menu then holds only
 * what the least privilege role may see, and this says why, with Retry. It appears only in that state.
 */
import { quiet } from './states.jsx'

export default function MeErrorNotice({ message, onRetry }) {
  return (
    <div role="alert" data-slot="access-error" className="fixed bottom-4 left-4 right-4 z-50 sm:left-auto sm:max-w-md rounded-xl p-4 border border-(--error)/20 bg-(--error-muted) text-sm text-(--error) flex flex-col gap-3 shadow-lg">
      <span>Your access could not be loaded, so the console shows only what anyone may see. {message}</span>
      <button type="button" className={quiet} onClick={onRetry}>Retry</button>
    </div>
  )
}
